export const contentBlock = {
    block(block) {
        return {
            name: 'Content box',
            fields: block.fields ?? [],
            type: 'content-box',
            uuid: block.uuid ?? 0,
            background_image: block.background_image ?? '',
            lock: block.lock ?? 0,
            connected_parent_conditional_id: block.connected_parent_conditional_id ?? [],
            role_id: block.role_id ?? 0
        }
    }
}